import React, { useEffect, useState } from 'react';
import { getAdminTourDepartures, updateTourDateSetting } from '../../services/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { toast } from 'sonner';

const AVAILABILITY_LABELS = { available: 'Müsait', limited: 'Son Kontenjan', full: 'Dolu', closed: 'Kapalı' };

const DepartureAdminRow = ({ tourId, dep, onSaved }) => {
  const [capacity, setCapacity] = useState(dep.capacity);
  const [status, setStatus] = useState(dep.status);
  const save = async () => {
    try {
      await updateTourDateSetting(tourId, dep.date, { capacity: Number(capacity), status });
      toast.success(`${dep.date} güncellendi`);
      onSaved();
    } catch (error) {
      toast.error(error.response?.data?.detail?.[0]?.msg || error.response?.data?.detail || 'Kaydedilemedi');
    }
  };
  return (
    <tr className={`border-t ${dep.is_past ? 'opacity-50' : ''}`} data-testid={`admin-departure-${dep.date}`}>
      <td className="p-2 text-sm whitespace-nowrap">{dep.date}{dep.end_date ? ` → ${dep.end_date}` : ''}{dep.is_past && ' (geçmiş)'}</td>
      <td className="p-2">
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="h-9 w-28" data-testid={`admin-departure-status-${dep.date}`}><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="open">Açık</SelectItem>
            <SelectItem value="closed">Kapalı</SelectItem>
            <SelectItem value="cancelled">İptal</SelectItem>
          </SelectContent>
        </Select>
      </td>
      <td className="p-2"><Input type="number" min="1" className="h-9 w-20" value={capacity} onChange={(e) => setCapacity(e.target.value)} data-testid={`admin-departure-capacity-${dep.date}`} /></td>
      <td className="p-2 text-sm text-center">{dep.booked}</td>
      <td className="p-2 text-sm text-center">{dep.remaining}</td>
      <td className="p-2 text-xs">{dep.status === 'cancelled' ? 'İptal' : AVAILABILITY_LABELS[dep.availability]}</td>
      <td className="p-2"><Button type="button" size="sm" onClick={save} data-testid={`admin-departure-save-${dep.date}`}>Kaydet</Button></td>
    </tr>
  );
};

export const DepartureManager = ({ tourId }) => {
  const [departures, setDepartures] = useState([]);
  const load = async () => {
    try {
      const { data } = await getAdminTourDepartures(tourId);
      setDepartures(data);
    } catch (error) {
      toast.error('Tarihler yüklenemedi');
    }
  };
  useEffect(() => { load(); }, [tourId]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="border-t pt-4" data-testid="admin-departure-manager">
      <h3 className="font-semibold mb-1">Tarih & Kontenjan Yönetimi</h3>
      <p className="text-xs text-gray-500 mb-3">Yeni tarih eklemek için yukarıdaki tarih alanını kullanıp turu kaydedin. Varsayılan kontenjan 30 kişidir; bekleyen ve onaylanan rezervasyonlar kontenjandan düşer.</p>
      {departures.length === 0 ? (
        <p className="text-sm text-gray-500">Bu turda tanımlı tarih yok.</p>
      ) : (
        <div className="overflow-x-auto rounded-lg border">
          <table className="w-full text-left">
            <thead className="bg-gray-50 text-xs text-gray-600">
              <tr><th className="p-2">Tarih</th><th className="p-2">Durum</th><th className="p-2">Kontenjan</th><th className="p-2">Dolu</th><th className="p-2">Kalan</th><th className="p-2">Görünüm</th><th className="p-2" /></tr>
            </thead>
            <tbody>
              {departures.map(dep => <DepartureAdminRow key={`${dep.date}-${dep.capacity}-${dep.status}-${dep.booked}`} tourId={tourId} dep={dep} onSaved={load} />)}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
